export const FIELD_PASSWORD = "password";
export const FIELD_REPEAT_PASSWORD = "repeat-password";
